import React, { useReducer, useEffect } from "react"
import { createContext } from "react"
import { TimeStampReducer } from "./useReducers"
import { getTimestamp } from "../../Data/constant"

export const TimestampContext = createContext({})

const InitialState = {
    duration: "this-week",
    startDate: "",
    endDate: "",
}

const LOCAL_KEY = "timestamp_state"

/**
 * Ensures the state always has computed startDate/endDate.
 * If dates are missing (e.g. first load or stale localStorage), recalculates them from duration.
 * @param {object} state - The timestamp state object.
 * @returns {object} State with guaranteed startDate and endDate values.
 */
const ensureDatesComputed = (state) => {
    if (state.duration && state.duration !== "custom" && (!state.startDate || !state.endDate)) {
        const { startDate, endDate } = getTimestamp("", "", state.duration)
        return { ...state, startDate, endDate }
    }
    return state
}

const TimestampProvider = (props) => {
    // Load from localStorage (fallback to InitialState)
    const loadState = () => {
        try {
            const saved = localStorage.getItem(LOCAL_KEY)
            const parsed = saved ? JSON.parse(saved) : InitialState
            return ensureDatesComputed(parsed)
        } catch {
            return ensureDatesComputed(InitialState)
        }
    }

    const [timestampState, timestampDispatch] = useReducer(TimeStampReducer, loadState())

    // Persist whenever state changes
    useEffect(() => {
        localStorage.setItem(LOCAL_KEY, JSON.stringify(timestampState))
    }, [timestampState])

    return (
        <TimestampContext.Provider value={{ timestampState, timestampDispatch }}>
            {props.children}
        </TimestampContext.Provider>
    )
}

export default TimestampProvider
